import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';

import {
  ClearButton,
  SelectDropDown,
  DatePicker
} from 'components/common/Elements/Elements';

import classes from './FiltersBlock.module.scss';

const FiltersBlock = ({
  filter,
  setFilter,
  startFilter,
  setStartFilter,
  filters,
  selectLoader,
  resetAllfilters,
  filterButton,
  setVisibleFilterSave,
  setVisibleFilterEdit,
  changeFilter,
  trigerResetDatePicker
}) => {
  const { t } = useTranslation(['activity']);

  const numberОfFilters = 5;

  const handleFilter = e => {
    setFilter({ ...filter, [e.target]: e.value, currentPage: 1 });
    setVisibleFilterSave('button');
    if (changeFilter !== 'Default') {
      setVisibleFilterEdit(true);
    }
  };

  function checkAndSetFilter(key, value) {
    if (!isEqual(filter[key], value)) {
      setFilter({ ...filter, [key]: value, currentPage: 1 });
      setStartFilter(!startFilter);
      setVisibleFilterSave('button');
      if (changeFilter !== 'Default') {
        setVisibleFilterEdit(true);
      }
    }
  }

  const handleDateChange = value => {
    const key = '_created_at';
    checkAndSetFilter(key, value);
  };

  return (
    <div className={cn(filterButton ? classes.filters : classes.filters_close)}>
      <SelectDropDown
        options={filters.platform}
        input={{ value: filter.platform, onChange: handleFilter }}
        name={'platform'}
        label={t('activity:customers.PLATFORM')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.newVersion}
        input={{ value: filter.newVersion, onChange: handleFilter }}
        name={'newVersion'}
        label={t('activity:filters.VERSION')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.status}
        input={{ value: filter.status, onChange: handleFilter }}
        name={'status'}
        label={t('activity:filters.STATUS')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <DatePicker
        label={t('activity:filters.CREATED_AT')}
        input={{
          value: Array.isArray(filter._created_at)
            ? { startDate: null, endDate: null }
            : filter._created_at,
          onChange: handleDateChange
        }}
        trigerResetDatePicker={trigerResetDatePicker}
      />
      <SelectDropDown
        options={filters.updatedByName}
        input={{ value: filter.updatedByName, onChange: handleFilter }}
        name={'updatedByName'}
        label={t('activity:filters.UPDATED_BY')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      {filters.isTestTenant && (
        <SelectDropDown
          options={
            filters['isTestTenant']
              ? filters['isTestTenant'].map(item =>
                  item === true ? 'True' : 'False'
                )
              : []
          }
          input={{ value: filter.isTestTenant, onChange: handleFilter }}
          name={'isTestTenant'}
          label={t('activity:filters.IS_TEST_TENANT')}
          closeTrigger={{
            trigger: startFilter,
            setTrigger: setStartFilter
          }}
          reload
          selectLoader={selectLoader}
        />
      )}
      <ClearButton
        className={classes.clear}
        onClick={() => resetAllfilters(false, true, false, true)}
        numberОfFilters={numberОfFilters}
      />
    </div>
  );
};

FiltersBlock.propTypes = {
  filter: PropTypes.object,
  setFilter: PropTypes.func,
  startFilter: PropTypes.bool,
  setStartFilter: PropTypes.func,
  filterButton: PropTypes.bool,
  filters: PropTypes.object,
  selectLoader: PropTypes.bool,
  trigerResetDatePicker: PropTypes.bool,
  resetAllfilters: PropTypes.func,
  setVisibleFilterSave: PropTypes.func,
  setVisibleFilterEdit: PropTypes.func,
  changeFilter: PropTypes.string
};

export default FiltersBlock;
